import produce from 'immer';

/**
 * @typedef {Object} ChatInfo
 * @property {number} queueId
 * @property {number[]} customerTagIds
 * @property {string} channelId
 */

/**
 * @typedef {Object} AgentDataItem
 * @property {string} agentLogin
 * @property {string} agentName
 * @property {ChatInfo[]} closedChatsInfo
 * @property {ChatInfo[]} inAttendanceChatsInfo
 */

/**
 * @typedef {Object} QueueDataItem
 * @property {number} queueId
 * @property {string} queueName
 * @property {ChatInfo[]} closedChatsInfo
 * @property {ChatInfo[]} inAttendanceChatsInfo
 * @property {ChatInfo[]} inWaitChatsInfo
 */

/**
 * @typedef {Object} MonitoringChatState
 * @property {AgentDataItem[]} agentData
 * @property {QueueDataItem[]} queueData
 */

/** @type {MonitoringChatState} */
const initialState = {
  data: []
};

/**
 * @param {MonitoringChatState} state
 * @param {Object} action
 * @param {string} action.type
 * @param {MonitoringChatState | AgentDataItem} action.payload
 * @returns {MonitoringChatState}
 */
export const monitoringChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@MONITORING_CHAT/UPDATE_ALL_MONITORING_SYNTHETIC_CHAT':
      return produce(state, (draft) => {
        draft.data = action.payload;
      });

    case '@MONITORING_CHAT/UPDATE_MONITORING_SYNTHETIC_CHAT':
      return produce(state, (draft) => {
        if (action.payload.chatId) {
          const index = draft?.data.findIndex(
            (data) => data.chatId === action.payload.chatId
          );

          if (index > -1) {
            draft.data[index] = action.payload;
          } else draft.data.push(action.payload);
        }
      });

    default:
      return state;
  }
};

/**
 * @param {Object} state
 * @param {MonitoringChatState} state.monitoringChat
 * @returns {MonitoringChatState}
 */
export const selectMonitoringChat = (state) => state.monitoringChat;
